<template>
  <div class="mt-2">
    <div class="details-title">{{ title }}</div>
    <div class="card card-body card-account bg-light">
      <div class="row">
        <div class="col-md-8">
          {{ accountData.company }}
          <br/>
          KvK: {{ accountData.coc_number }}
          <br/>
          BTW: {{ accountData.tax_number }}
        </div>
        <div class="col-md-5 text-right">
          <div @click="$bvModal.show('company-details-modal')" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <b-modal ref="company-details-modal" id="company-details-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-13">
                <label for="company" class="col-form-label">Bedrijfsnaam</label>
                <input
                  id="company"
                  name="company"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.company.$error}"
                  v-model="company"
                  @blur="$v.company.$touch()"
                  placeholder="Bedrijfsnaam"
                >
                <span v-if="$v.company.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. de bedrijfsnaam in.</strong>
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <label for="coc_number" class="col-form-label">KvK nummer</label>
                <input
                  id="coc_number"
                  name="coc_number"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.coc_number.$error}"
                  v-model="coc_number"
                  @blur="$v.coc_number.$touch()"
                  placeholder=""
                >
                <span v-if="$v.coc_number.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. het KvK nummer in.</strong>
                </span>
              </div>
              <div class="col-md-7">
                <label for="tax_number" class="col-form-label">BTW nummer</label>
                <input
                  id="tax_number"
                  name="tax_number"
                  type="text"
                  class="form-control"
                  v-model="tax_number"
                  placeholder=""
                >
              </div>
            </div>
          </form>
        </div>

        <div
          v-if="companyDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': companyDetailsStatus.success, 'alert-danger': !companyDetailsStatus.success }"
        >
          <strong>{{ companyDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
          class="btn btn-oldevuuren btn-round w-100">{{ title }} opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="companyDetailsBusy" icon="spinner" spin/>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { minLength, required } from 'vuelidate/lib/validators'

  import { MUTATE_COMPANY_DETAILS_STATUS, SAVE_COMPANY_DETAILS } from '../../../store/types'

  export default {
    props: ['accountData'],
    data() {
      return {
        title: 'Bedrijfsgegevens',
        company: this.accountData.company,
        coc_number: this.accountData.coc_number,
        tax_number: this.accountData.tax_number
      }
    },
    validations: {
      company: {
        required,
        minLen: minLength(2)
      },
      coc_number: {
        required,
        minLen: minLength(2)
      }
    },
    computed: {
      companyDetailsStatus() {
        return this.$store.getters.companyDetailsStatus
      },
      companyDetailsBusy() {
        return this.$store.getters.companyDetailsBusy
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['company-details-modal'].hide()
        // discard changes
        this.company = this.accountData.company
        this.coc_number = this.accountData.coc_number
        this.tax_number = this.accountData.tax_number
      },
      saveDetails() {
        const formData = {
          company: this.company,
          coc_number: this.coc_number,
          tax_number: this.tax_number
        }
        this.$store.dispatch(SAVE_COMPANY_DETAILS, formData).then(() => {
          if (this.companyDetailsStatus.success) {
            this.$refs['company-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_COMPANY_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
